"use client";

function hexToRgba(hex, alpha) {
  let c = hex.replace('#', '');
  if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
  const num = parseInt(c, 16);
  return `rgba(${(num>>16)&255},${(num>>8)&255},${num&255},${alpha})`;
}

export default function LoadMoreButton({ 
  isLoading, 
  onClick, 
  loadingComponent = null,
  className = "",
  text = "Xem thêm",
  hasMore = true
}) {
  if (!hasMore) return null;
  
  function handleMouseOver(e) {
    const style = getComputedStyle(e.currentTarget);
    let color = style.getPropertyValue('--theme-primary').trim();
    e.currentTarget.style.backgroundColor = hexToRgba(color, 0.7);
    e.currentTarget.style.color = '#222';
  }

  function handleMouseOut(e) {
    e.currentTarget.style.backgroundColor = 'var(--theme-primary)';
  }

  return (
    <div className="py-4 text-center">
      {isLoading ? (
        loadingComponent
      ) : (
        <button
          onClick={onClick}
          className={`px-6 py-2 text-white rounded-lg border-none transition-colors ${className}`}
          style={{ backgroundColor: 'var(--theme-primary)' }}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          {text}
        </button>
      )}
    </div>
  );
}
